(() => {
  window.__BERINGIA_HAWL_1TO1__ = window.__BERINGIA_HAWL_1TO1__ || {};

  const initializedCards = new WeakSet();
  const initializedBuyButtons = new WeakSet();
  const observed = new WeakSet();

  document.documentElement.classList.add('js');

  function scrollToProduct() {
    const selectors = [
      '[id^="ProductInfo-"]',
      '.product__info-container',
      '.product-info',
      '.product-form',
      'product-info'
    ];

    let target = null;
    for (const selector of selectors) {
      target = document.querySelector(selector);
      if (target) break;
    }

    if (target) {
      const y = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function initSizeCards(root) {
    const cards = Array.from(root.querySelectorAll('[data-hawl-size-card]'));

    cards.forEach((card) => {
      if (initializedCards.has(card)) return;
      initializedCards.add(card);

      card.addEventListener('click', (event) => {
        const href = card.getAttribute('href');
        event.preventDefault();

        cards.forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-current', selected);
          item.setAttribute('aria-current', selected ? 'true' : 'false');
        });

        if (href) {
          window.setTimeout(() => {
            window.location.href = href;
          }, 160);
        }
      });
    });
  }

  function initBuyButtons(root) {
    root.querySelectorAll('[data-hawl-buy]').forEach((button) => {
      if (initializedBuyButtons.has(button)) return;
      initializedBuyButtons.add(button);
      button.addEventListener('click', scrollToProduct);
    });
  }

  function initReveal(root) {
    const els = Array.from(root.querySelectorAll('.hawl-reveal'));

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach((el) => {
      if (observed.has(el)) return;
      observed.add(el);
      observer.observe(el);
    });
  }

  function init(root) {
    if (!root) return;
    initSizeCards(root);
    initBuyButtons(root);
    initReveal(root);
  }

  function refresh() {
    document.querySelectorAll('.hawl-module').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);

  if (document.readyState !== 'loading') refresh();
})();